import { Button } from '@loomhq/lens';
import React from 'react';
import { useDispatch } from 'react-redux';

import * as analytics from 'utilities/analytics';

import ExploreTeamLibraryImg from 'img/workspace-onboarding/explore-team-library.png';

import DashboardOnboardingCard from '../..';
import { completeElementHandler } from '../../../utilities';
import { DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED } from '../../../../../../constants/events';
import { TEAM_VIDEOS_PAGE } from '../../../../../../constants/routes';
import { useGetSelectedWorkspace } from '../../../../../../hooks/workspace';
import { EXPLORE_TEAM_LIBRARY_CARD_KEY } from '../../../../../../../../shared/constants/workspaceOnboarding';
import {
  PRIVATE_WORKSPACE,
  TEAM_WORKSPACE,
} from '../../../../../../../../shared/constants/workspaces';

export const filterFunction = (library, isAdmin, libraryVideoCounts) => {
  if (!isAdmin && library === PRIVATE_WORKSPACE) {
    const teamVideosExist = libraryVideoCounts[TEAM_WORKSPACE] > 0;

    return teamVideosExist;
  }

  return true;
};

const ExploreTeamLibraryCard = ({ cardConfig }) => {
  const dispatch = useDispatch();
  const selectedWorkspace = useGetSelectedWorkspace();

  if (!selectedWorkspace) {
    return null;
  }

  const primaryAction = (
    <Button
      onClick={() => {
        analytics.track(DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED, {
          type: 'primary',
          card: EXPLORE_TEAM_LIBRARY_CARD_KEY,
        });

        completeElementHandler(
          dispatch,
          EXPLORE_TEAM_LIBRARY_CARD_KEY,
          selectedWorkspace.id
        );

        window.location.href = TEAM_VIDEOS_PAGE;
      }}
    >
      Take me there
    </Button>
  );
  const centerpiece = <img src={ExploreTeamLibraryImg} />;

  return (
    <DashboardOnboardingCard
      cardKey={EXPLORE_TEAM_LIBRARY_CARD_KEY}
      cardConfig={cardConfig}
      heading="Explore the Team Library"
      description="Browse videos created by your team."
      centerpiece={centerpiece}
      primaryAction={primaryAction}
      completeMessage="You have explored the Team Library."
    />
  );
};

export default ExploreTeamLibraryCard;
